module.exports = __webpack_public_path__ + "media/images/banner/3-7e7d154cd0983742a600e5ba4f0e99f8.jpg";